import { TApplicationState } from 'shared/types/redux';

export const fromAgentPropsCountDisplaySelector = (state: TApplicationState) => {
  return state.newbuilding.stats.fromAgentsPropsCountDisplay;
};
